import PetitionerError from './PetitionerError';
class PetitionerIsNotRegistered extends PetitionerError {
    petitionerId;
    constructor(petitionerId, options) {
        super('Petitioner is not registered', options);
        this.petitionerId = petitionerId;
    }
}
export default PetitionerIsNotRegistered;
